<template>
  <div>
    <otp class=" mb-3 mt-5 pt-3" />
  </div>
</template>

<script>
import OTP from '@/components/cleanui/system/Auth/Otp'
export default {
  components: {
    otp: OTP,
  },
}
</script>
